import React from 'react';
import styled from 'styled-components';
import { Link } from '@buoyhealth/common.buoy-button';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from '@buoyhealth/common.buoy-input';

const StyledLink = styled(Link)`
  font-size: 14px;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 14px;
  }
`;

type TermsAndConditionsEmailProps = {
  consentCopy?: string;
  customStyle?: any;
  onChange?: (event: any) => void;
  termsAgreed: boolean;
  termsCopy?: string;
};

const TermsAndConditions = ({
  consentCopy,
  customStyle,
  termsAgreed,
  termsCopy,
  onChange,
}: TermsAndConditionsEmailProps) => {
  return (
    <Grid item sx={{ paddingLeft: 1.5, marginTop: 2, ...(customStyle && customStyle) }}>
      {consentCopy ? (
        <StyledFormControlLabel
          control={<Checkbox checked={termsAgreed} onChange={onChange} />}
          label={<span className="bp-text-sm">{consentCopy}</span>}
        />
      ) : (
        <StyledFormControlLabel
          control={<Checkbox checked={termsAgreed} onChange={onChange} />}
          label={
            <span>
              {termsCopy} Buoy&apos;s{' '}
              <StyledLink href="/terms" target="_blank">
                Terms of Use
              </StyledLink>{' '}
              and{' '}
              <StyledLink href="/privacy" target="_blank">
                Privacy Policy
              </StyledLink>
              .
            </span>
          }
        />
      )}{' '}
    </Grid>
  );
};

export default TermsAndConditions;
